import React from 'react';
import _ from 'lodash';
import AppWindow from './AppWindow';

interface WindowsInViewportProps {
  windows: string[];
  topSectionSum: number;
  bottomSectionSum: number;
  maxHeight: number;
  maxWidth: number;
  activeWindow: string;
}
const WindowsInViewport: React.FC<WindowsInViewportProps> = ({
  windows,
  topSectionSum,
  bottomSectionSum,
  maxHeight,
  maxWidth,
  activeWindow,
}) => {
  const windowView = (id: string, index: number) => (
    <AppWindow
      key={id}
      id={id}
      isActive={id === activeWindow}
      zIndex={id === activeWindow ? windows.length + 1 : index + 1}
      topSectionSum={topSectionSum}
      bottomSectionSum={bottomSectionSum}
      maxHeight={maxHeight}
      maxWidth={maxWidth}
    />
  );

  return <>{windows.map(windowView)}</>;
};

const compareProps = (
  prevProps: WindowsInViewportProps,
  newProps: WindowsInViewportProps
) => {
  return (
    _.isEqual(prevProps.windows, newProps.windows) &&
    _.isEqual(prevProps.maxHeight, newProps.maxHeight) &&
    _.isEqual(prevProps.maxWidth, newProps.maxWidth) &&
    _.isEqual(prevProps.activeWindow, newProps.activeWindow)
  );
};

export default React.memo(WindowsInViewport, compareProps);
